import React from 'react';
import styled from '@emotion/styled';

import { ComponentStyle, ProductComponentProps } from '../../types/types';

import VerticalSplit from '../shared/containers/VerticalSplit';
import { BenefitsBackgroundPattern } from './BenefitsBackgroundPattern';
import { BenefitsImage } from './BenefitsImage';
import { BenefitsHeader } from './BenefitsHeader';
import { BenefitsPoints } from './BenefitsPoints';
import { BenefitsTp } from './StyleE/BenefitsTp';
import { extractPaletteColors } from '../helpers';

import { productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle } from '../shared/styles';
import { BenefitsLogo } from './BenefitsLogo';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const BenefitsContainer = styled(VerticalSplit)({
  position: 'relative',

  color: 'var(--color-body)',

  '&.D': {
    color: 'var(--color-white)',
  },

  '&.A h2': {
    color: 'var(--color-primary)',
  },

  '&.B h2': {
    color: 'var(--color-black)',
  },

  '&.C h2': {
    color: 'var(--color-black)',
  },

  '&.D h2': {
    color: 'var(--color-secondary)',
  },

  '&.F h2': {
    color: 'var(--color-primary)',
  },

  '&.G h2': {
    color: 'var(--color-primary)',
  },

  '&.H h2': {
    color: 'var(--color-primary)',
  },
});

const BenefitsContentContainer = styled.div([
  productComponentContainerPaddingStyle,
  productComponentContainerBottomPaddingStyle,
  {
    '&.B': {
      backgroundColor: 'var(--color-secondary)',
    },
    '&.C': {
      backgroundColor: 'var(--color-secondary)',
    },
    '&.D': {
      backgroundColor: 'var(--color-dark)',
    },
    '&.F, &.G': {
      paddingBottom: pxToRem(16),

      [mqBreakpoints.tablet]: {
        paddingBottom: pxToRem(64),
        paddingRight: pxToRem(200),
      },

      [mqBreakpoints.desktop]: {
        paddingTop: pxToRem(160),
        paddingBottom: pxToRem(100),
        paddingRight: pxToRem(120), // reset and override tablet paddingRight
      },
    },
  },
]);

export const Benefits: React.FC<ProductComponentProps> = props => {
  const { title, points, description, style, image, palette, logo } = props.productComponent;

  const paletteColors = extractPaletteColors(palette);
  const componentIdx = props.index ?? 0;
  const rowReverse = style === ComponentStyle.A || style === ComponentStyle.F || style === ComponentStyle.H;

  return style === 'E' ? (
    <BenefitsTp index={componentIdx} title={title} points={points} description={description} image={image} logo={logo} paletteBackgroundColor={paletteColors.paletteBackgroundColor} paletteTextColor={paletteColors.paletteTextColor} />
  ) : (
    <BenefitsContainer id={`mp-product-benefits-${componentIdx}`} className={style} rowReverse={rowReverse} data-testid='mp-product-benefits'>
      {style === 'H' && <BenefitsBackgroundPattern />}
      {image && <BenefitsImage image={image} />}
      {logo && <BenefitsLogo logo={logo} paletteColors={paletteColors} />}
      <BenefitsContentContainer className={style}>
        <BenefitsHeader title={title} strapline={description} style={style} />
        <BenefitsPoints points={points} style={style} />
      </BenefitsContentContainer>
    </BenefitsContainer>
  );
};
